import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'phone' })
export class PhonePipe implements PipeTransform {
  transform(rawPhone: string): string {
    return formatPhone(rawPhone);
  }
}

/**
 * @param rawPhone (string)
 * @return (string)
 */
export function formatPhone(rawPhone: string): string {
  if (rawPhone.length === 10) {
    const area = rawPhone.slice(0, 3) + '';
    const local = '' + rawPhone.slice(3, 6) + '-' + rawPhone.slice(6);
    return '' + area + '-' + local;
  } else {
    return rawPhone;
  }
}
